export default __webpack_public_path__ + "static/media/juice-fruit-product-l-mobile@2x.211a87c1.png";